module.exports = __webpack_public_path__ + "static/media/4.bf345c69.jpg";